import React from 'react';
import { Theme, ThemeProvider } from '@mui/material';

import { HOME } from 'ha/constants/pageNames';
import { Page } from 'ha/modules/Page';
import { defaultFont } from 'ha/constants/fonts/default';
import { sourceSansHeaders as sharpSansHeadersFont } from 'ha/constants/fonts/sourceSansHeaders';
import { useOptionalHermes } from 'ha/modules/Hermes';

import Helmet from 'react-helmet';
import {
  unlessScript,
  unlessScriptAttributes,
} from 'ha/server/routers/ha/scripts/unless';

import { useFeatureFlags } from 'ha/modules/FeatureFlags';
import { HomeLayout } from '../components/HomeLayout';
import { HermesData } from '../types';

// to avoid new theme creation each rerender
const homeNextTheme: (outerTheme: Theme) => Theme = outerTheme => ({
  ...outerTheme,
  typography: {
    ...outerTheme.typography,
    h1: {
      ...outerTheme.typography.h1,
      fontFamily: sharpSansHeadersFont.fontFamily,
    },
    h2: {
      ...outerTheme.typography.h2,
      fontFamily: sharpSansHeadersFont.fontFamily,
    },
    h3: {
      ...outerTheme.typography.h3,
      fontFamily: sharpSansHeadersFont.fontFamily,
    },
  },
});

const HomePage: React.FC = () => {
  const { data } = useOptionalHermes<HermesData>();
  const { enableUnlessScript } = useFeatureFlags();
  return (
    <Page
      name={HOME}
      noFollowFooter={false}
      activeFonts={[defaultFont, sharpSansHeadersFont]}
      remarketingTag={{
        hrental_id: '',
        hrental_pagetype: 'homepage',
        hrental_startdate: '',
        hrental_enddate: '',
        hrental_totalvalue: '',
      }}
    >
      <Helmet>
        {enableUnlessScript === 'on' && (
          <script {...unlessScriptAttributes}>{unlessScript()}</script>
        )}
      </Helmet>

      <ThemeProvider theme={homeNextTheme}>
        <HomeLayout data={data} />
      </ThemeProvider>
    </Page>
  );
};

export { HomePage };
